import { Injectable, isDevMode } from '@angular/core';
import { Resolve } from '@angular/router';
import * as uuid from 'uuid/v4';
import { LogService } from './log.service';
import { EventType } from '../../models/logs.model';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { ResolverService } from '../resolver/resolver.service';
import { SnackBarService } from '../../../shared';


@Injectable()
export class LogResolverService implements Resolve<Promise<boolean>> {

  constructor(
    private localStorageService: LocalStorageService,
    private logService: LogService,
    private snackbarService: SnackBarService,
    private resolverService: ResolverService
  ) { }

  private checkUUID(): Promise<boolean> {
    return new Promise((resolve, reject) => {

      if (!!this.localStorageService.browserID && !!this.localStorageService.logToken) {
        const token = this.localStorageService.logToken;
        if (isDevMode() || true) {
          resolve(true);
          return;
        }
        this.logService.createEventLog(
          EventType.APP_OPEN,
        ).subscribe(
          success => {
            resolve(true);
          },
          error => {
            this.snackbarService.showSnack(error.detail);
            reject();
          }
        )
      } else {
        const device_id = this.generateUUID();
        if(isDevMode() || true) {
          resolve(true);
          return;
        }
        this.logService.registerDevice(device_id, 'Browser', window.navigator.appVersion.substring(0, 99)).subscribe(success => {
          this.localStorageService.logToken = success.token;
          resolve(true);
        },
          error => {
            this.snackbarService.showSnack(error.detail);
            reject();
          })
      }
    })
  }

  private generateUUID() {
    const device_id = uuid();
    this.localStorageService.browserID = device_id;
    return device_id;
  }

  public resolve(): Promise<boolean> {
    return this.checkUUID();
  }
}
